import React from 'react'
import {Component} from 'react'
import './map-link.scss'

export default class extends Component {
  render(){
    return (
      <a
        className="map-link"
        target="_blank"
        href={
          "http://maps.google.com/?q=" +
          this.props.latitude + ',' +
          this.props.longitude }
        >
        <i className="fa fa-map-marker"></i>
        {this.props.text}
      </a>
    )
  }
}
